<div class="flex justify-between items-center gap-8">
  <div class="flex gap-4">
    <button
      class="btn-header btn-text"
      (mousedown)="openYearSelectionView($event)"
      data-cy="Calendar:Header:Navigate"
    >
      {{ selectedCalendarDate | date: dateFormat }}
    </button>
    @if (isMobile) {
      <button
        class="btn-header"
        [class.active]="isCalendarVisible"
        (mousedown)="toggleCalendarVisibility($event)"
      >
        <mat-icon
          svgIcon="icon_chevron_down_16"
          class="transition-transform"
          [class.rotate-180]="isCalendarVisible"
        />
      </button>
    }
  </div>
  <div class="flex gap-8">
    <button
      type="button"
      class="btn-header btn-header-nav"
      (mousedown)="selectPreviousDate($event)"
      data-cy="Calendar:Header:Previous"
    >
      <mat-icon svgIcon="icon_chevron_left_16" />
    </button>
    <button
      type="button"
      class="btn-header btn-header-nav"
      (mousedown)="selectNextDate($event)"
      data-cy="Calendar:Header:Next"
    >
      <mat-icon svgIcon="icon_chevron_right_16" />
    </button>
  </div>
</div>
